import { MicroSiteTextSubPage } from 'components/MicroSite/TextSubPage';

const ScreenMicroSiteTextSubPage = () => <MicroSiteTextSubPage />;

export default ScreenMicroSiteTextSubPage;
